import { memo } from 'react';
import { Box, Button, CssBaseline, Grid, Stack, Typography } from '@mui/material';
import CustomCard from 'components/cmn/CustomCard';
import PageMainTitle from 'components/cmn/PageMainTitle';
import DiagnosticTable from 'components/diagnostic-management/DiagnosticTable';
import { useNavigate } from 'react-router-dom';

function DiagnostricManagementPage(): JSX.Element {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/admin/diagnostic-management/regist');
  };
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Grid container>
        <Grid item xs={12} sx={{ mb: 2 }}>
          <PageMainTitle title="진단관리" />
          <Typography sx={{ typography: 's20w700', display: 'flex', justifyContent: 'flex-start', mt: 4 }}>
            진단 list
          </Typography>
          <CustomCard sx={{ mt: 2 }} content={false} border>
            <DiagnosticTable />
          </CustomCard>
          <Stack direction="row" justifyContent="center" alignItems="center" sx={{ display: 'flex', mt: 4 }}>
            <Button variant="outlined" color="primary" onClick={handleClick} sx={{ height: 40 }}>
              진단 추가
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}

export default memo(DiagnostricManagementPage);
